export default __webpack_public_path__ + "static/media/BGMusic.e2e3c3c4.mp3";